// DeleteGoalConfirmDialog.jsx - Confirmation Dialog for Deleting a Goal from User KPI

import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    Alert
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const DeleteGoalConfirmDialog = ({ open, goal, onClose, onConfirm }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth disableRestoreFocus>
            <DialogTitle>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <WarningIcon color="error" />
                    <Typography variant="h6">Delete Goal</Typography>
                </Box>
            </DialogTitle>

            <DialogContent dividers>
                <Alert severity="warning" sx={{ mb: 2 }}>
                    This action cannot be undone!
                </Alert>

                <Typography variant="body1" gutterBottom>
                    Are you sure you want to delete this goal from the user's KPI assignment?
                </Typography>

                {goal && (
                    <Box sx={{ mt: 2, p: 2, bgcolor: 'background.default', borderRadius: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {goal.goal?.name || 'Unknown Goal'}
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                            <Typography variant="caption" color="text.secondary">
                                <strong>Category:</strong> {goal.category}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                <strong>Weight:</strong> {parseFloat(goal.weight).toFixed(0)}
                            </Typography>
                        </Box>
                    </Box>
                )}
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={onClose} variant="outlined">
                    Cancel
                </Button>
                <Button 
                    onClick={onConfirm} 
                    variant="contained" 
                    color="error"
                    startIcon={<WarningIcon />}
                >
                    Delete Goal
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteGoalConfirmDialog;
